<template>
  <div>
    <div
      style="position: fixed; top: 20px; z-index: 2; backdrop-filter: blur(2px)"
      v-if="loaderStatus"
    >
      <Spinner />
    </div>
    <div class="main-container overflow-hidden">
      <div
        class="
          asc-page-heading
          d-flex
          align-items-center
          justify-content-between
        "
      >
        <div class="d-flex align-items-center">
          <img
            @click="goBackPointer"
            class="mr-3 pointer"
            src="../../assets/customfield/blueBackArrow.svg"
            alt=""
          />
          CV Search
        </div>

        <div class="bluebtn d-flex">
          <b-button class="acs-addBtn w-140px" @click="goToBookmarked">
            <img
              src="../../assets/cvsearch/whitebookmark.svg"
              alt
              class="mr-2"
            />
            <span class>Candidates</span>
          </b-button>
          <b-button
            v-if="roles.includes('SAVE_SEARCH')"
            @click="createSearch()"
            class="acs-addBtn w-140px ml-3"
          >
            <img
              src="../../assets/img/accessconnew/whitePlus.svg"
              alt
              class="mr-2"
            />
            <span class>New Search</span>
          </b-button>
        </div>
      </div>
      <div class="cv-main-container">
        <!-- WHEN NO CV SEARCH -->
        <div
          class="
            d-flex
            flex-column
            align-items-center
            justify-content-center
            w-100
            h-100
          "
          v-if="
            savedSearches &&
            !savedSearches.length &&
            !loaderStatus &&
            !isFiltered &&
            !searchQuery
          "
        >
          <img src="../../assets/cvsearch/nocvsearch.svg" alt="" />
          <span class="text-center cv-grey-txt"
            >There are no saved search, click on<br />
            “+ New Search” to create new search.</span
          >
        </div>
        <!-- SAVED SEARCH TABLE  -->
        <div
          v-else-if="savedSearches || isFiltered || searchQuery"
          class="h-100"
        >
          <div
            class="
              border-bottom
              d-flex
              align-items-center
              justify-content-between
              pt-2
              pb-2
            "
          >
            <div class="dashboardAdmin-cards-head ml-3">Saved Search</div>
            <div class="mr-3 pr-1 position-relative bluebtn">
              <b-button
                ref="filterBtn"
                @click="toggleFilter"
                class="
                  acs-addBtn
                  d-flex
                  align-items-center
                  justify-content-center
                  w-110px
                  position-relative
                "
              >
                <div :class="{ 'cv-filter-dot': isFiltered }"></div>
                <img
                  src="../../assets/panelist/filter_pan.svg"
                  alt=""
                  class="mr-2"
                />
                Filter
              </b-button>
              <div
                ref="filter"
                v-if="showFilter"
                class="cv-filter-card"
                v-closable="{
                  exclude: ['filter', 'filterBtn'],
                  handler: 'closeFilter',
                }"
              >
                <div class="topDiv cv-field panellist-tags" @click.stop="">
                  <label class="acs-input-head">Keywords</label>
                  <b-form-tags
                    class="text-truncate cv-input-pan w-100"
                    placeholder="Enter Keywords"
                    v-model="tempFilter.keywords"
                    duplicate-tag-text=""
                    invalid-tag-text=""
                    :tag-validator="validateKeywords"
                    type="text"
                    remove-on-delete
                  ></b-form-tags>
                </div>
                <div class="hint-txt ml-2 pl-1 mt-1">
                  Press "Enter" to add keywords
                </div>
                <div class="acs-input-head mt-4">
                  Experience <span class="cv-grey-small-txt">(in years)</span> :
                </div>
                <div class="d-flex mt-1">
                  <div class="w-50">
                    <b-form-input
                      class="cs-laptopinput no-spinner"
                      placeholder="Min"
                      v-model="tempFilter.experienceFrom"
                      type="text"
                      @keypress="preventKeys($event, ['e', '+', '-'])"
                    ></b-form-input>
                  </div>
                  <div class="w-50 ml-2">
                    <b-form-input
                      class="cs-laptopinput no-spinner"
                      placeholder="Max"
                      v-model="tempFilter.experienceTo"
                      type="text"
                      @keypress="preventKeys($event, ['e', '+', '-'])"
                    ></b-form-input>
                  </div>
                </div>
                <div class="d-flex justify-content-between mt-3">
                  <div>
                    <b-button
                      class="acs-cancelBtn-filter"
                      @click="showFilter = false"
                      >Cancel</b-button
                    >
                  </div>
                  <div class="d-flex">
                    <b-button
                      class="acs-cancelBtn-filter mr-2"
                      @click="clearFilter"
                      :disabled="!isFiltered"
                      >Reset</b-button
                    >
                    <b-button
                      class="acs-cancelBtn-filter"
                      @click="applyFilter"
                      :disabled="!isFilterChanged"
                      >Apply</b-button
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="
              (isFiltered || searchQuery) &&
              savedSearches.length === 0 &&
              !loaderStatus
            "
            class="
              d-flex
              flex-column
              align-items-center
              justify-content-center
              w-100
            "
            style="height: calc(100% - 165px)"
          >
            <img src="../../assets/cvsearch/nocvsearch.svg" alt="" />
            <span class="text-center cv-grey-txt"
              >No results found for the
              {{ isFiltered ? "selected filters" : "search" }}. <br />
              Please try again with different
              {{ isFiltered ? "filter" : "search" }}.</span
            >
          </div>
          <div v-else>
            <div class="cvsearch-main-table">
              <div class="cvsearch-table-head">
                <div class="cvcol-1">
                  Search Name

                  <img
                    v-if="sort === 0"
                    class="ml-2"
                    src="../../assets/img/accessconnew/nosort.svg"
                    alt=""
                    @click="changeSort"
                  />
                  <img
                    v-else-if="sort === 1"
                    class="ml-2"
                    src="../../assets/img/accessconnew/ascSort.svg"
                    alt=""
                    @click="changeSort"
                  />
                  <img
                    v-else
                    class="ml-2"
                    src="../../assets/img/accessconnew/descSort.svg"
                    alt=""
                    @click="changeSort"
                  />
                </div>
                <div class="cvcol-1">Keywords</div>
                <div class="cvcol-1">
                  Experience <span class="cv-blue-small-txt">(in years)</span>
                </div>
                <div class="cvcol-1">Current Location</div>
                <div class="cvcol-5 text-center">Actions</div>
              </div>
              <div class="cvsearch-table-body" ref="table-body">
                <div
                  v-for="search in savedSearches"
                  :key="search.searchID"
                  class="cvsearch-table-row"
                >
                  <div class="cv-blueRole"></div>
                  <div class="cvcol-1 pr-3">
                    <span
                      class="text-truncate truncate-section"
                      v-b-tooltip.hover="search.title"
                    >
                      {{ search.title }}
                    </span>
                  </div>
                  <div class="cvcol-1 pr-3">
                    <span
                      class="text-truncate truncate-section"
                      v-b-tooltip.hover="
                        search.keywords ? search.keywords.join(', ') : ''
                      "
                    >
                      {{
                        (search.keywords && search.keywords.join(", ")) || "-"
                      }}
                    </span>
                  </div>
                  <div class="cvcol-1">
                    {{
                      formatExperience(
                        search.experienceFrom,
                        search.experienceTo
                      ) || "-"
                    }}
                  </div>
                  <div class="cvcol-1 pr-3">
                    <span
                      class="text-truncate truncate-section"
                      v-b-tooltip.hover="
                        search.location ? search.location.join('', '') : ''
                      "
                    >
                      {{
                        (search.location ? search.location.join(", ") : "-") ||
                        "-"
                      }}
                    </span>
                  </div>
                  <div
                    class="
                      cvcol-5
                      d-flex
                      align-items-center
                      justify-content-center
                    "
                  >
                    <!-- TAKE DISABLE SVG FROM ACCESS CONTROL -->
                    <div class="mr-3 pointer">
                      <img
                        src="../../assets/img/accessconnew/blueEye.svg"
                        alt=""
                        @click="viewSearch(search)"
                        v-b-tooltip.hover="'View'"
                      />
                    </div>
                    <div
                      v-if="roles.includes('PUT_SAVED_SEARCH')"
                      class="mr-3 pointer"
                    >
                      <img
                        src="../../assets/img/accessconnew/blueEdit.svg"
                        alt=""
                        @click="editSearch(search)"
                        v-b-tooltip.hover="'Edit'"
                      />
                    </div>
                    <div
                      v-if="roles.includes('DELETE_SAVED_SEARCH')"
                      class="pointer"
                    >
                      <img
                        src="../../assets/img/accessconnew/blueBin.svg"
                        alt=""
                        @click="deleteSearch(search)"
                        v-b-tooltip.hover="'Delete'"
                      />
                    </div>
                  </div>
                </div>
                <div v-if="loadingMore" class="d-flex justify-content-center">
                  <b-spinner label="Loading..."></b-spinner>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <transition name="cvslide">
        <div v-if="showSidePanel" class="cvsearch-trans-main-container">
          <div class="p-2">
            <div
              class="
                border-bottom
                d-flex
                align-items-center
                justify-content-between
                position-relative
                pl-3
                pt-2
                pb-3
                pr-4
              "
            >
              <div class="cs-bold-txt ml-3 mt-1 mb-1">
                {{ isViewing ? "View" : isEditing ? "Edit" : "Add New" }} Search
              </div>
              <div>
                <img
                  v-if="isViewing && roles.includes('PUT_SAVED_SEARCH')"
                  src="../../assets/img/accessconnew/blueEdit.svg"
                  alt=""
                  @click="editSearch(search)"
                  v-b-tooltip.hover="'Edit'"
                  class="mr-4"
                />
                <img
                  class="rotate-on-hover pointer"
                  @click="cancelSearch"
                  src="../../assets/img/accessconnew/blueCross.svg"
                  alt
                />
              </div>
              <img
                class="cv-pos-backarrow pointer"
                @click="cancelSearch"
                src="../../assets/img/accessconnew/boxBackArrow.svg"
                alt
              />
            </div>
            <div class="cv-trans-body pt-1 pl-3 pr-3 pb-3">
              <div class="mt-2" v-if="!isCreating">
                <div class="acs-input-head">Search name</div>
                <div class="mt-1">
                  <b-form-input
                    class="cs-laptopinput"
                    placeholder="Enter"
                    :disabled="isViewing"
                    v-model="search.title"
                  ></b-form-input>
                </div>
              </div>
              <div :class="isCreating ? 'mt-2' : 'mt-3'">
                <div class="topDiv cv-field panellist-tags" @click.stop="">
                  <label class="acs-input-head">Keywords</label>
                  <div
                    class="mt-1"
                    :class="
                      isViewing ? 'cs-laptopinput-disable' : 'cs-laptopinput'
                    "
                  >
                    <div class="d-flex flex-nowrap cvsearch-custom-cv-tags">
                      <div class="d-flex flex-nowrap">
                        <div
                          v-for="(keyword, index) in search.keywords"
                          :key="index"
                          :class="isViewing ? 'cv-greytag' : 'cv-bluetag w-100'"
                        >
                          <template v-if="isViewing">
                            <div>
                              <img
                                v-if="
                                  search.mandatoryKeywords.includes(keyword)
                                "
                                src="../../assets/cvsearch/greyfilledstar.svg"
                                alt=""
                              />
                              <img
                                v-else
                                src="../../assets/cvsearch/greyEmptystar.svg"
                                alt=""
                              />
                            </div>

                            <div class="ml-1 mr-1">{{ keyword }}</div>
                          </template>
                          <template v-else>
                            <div style="width: 15px">
                              <img
                                class="pointer"
                                v-if="
                                  search.mandatoryKeywords.includes(keyword)
                                "
                                src="../../assets/cvsearch/filledstar.svg"
                                alt=""
                                @click="removeMandatoryKeyword(keyword)"
                              />
                              <img
                                class="pointer"
                                v-else
                                src="../../assets/cvsearch/emptystar.svg"
                                alt=""
                                @click="addMandatoryKeyword(keyword)"
                              />
                            </div>

                            <div
                              class="ml-2 mr-2 text-truncate"
                              style="
                                min-width: auto;
                                max-width: 290px !important;
                              "
                            >
                              {{ keyword }}
                            </div>
                            <div>
                              <img
                                class="pointer"
                                src="../../assets/cvsearch/bluetagcross.svg"
                                alt=""
                                @click="removeKeyword(index)"
                              />
                            </div>
                          </template>
                        </div>
                      </div>
                      <b-form-input
                        class="pl-0"
                        placeholder="Enter Keywords"
                        v-if="!isViewing"
                        v-model="currentKeyword"
                        @keydown="addKeyword"
                      ></b-form-input>
                    </div>
                  </div>
                </div>
                <div class="d-flex justify-content-between">
                  <div class="cv-small-grey mt-1">
                    {{
                      search.keywords.length
                        ? "Click on star to make it as mandatory skill"
                        : 'Press "Enter" to add keywords'
                    }}
                  </div>
                  <div
                    class="position-relative cv-small-grey"
                    :class="!isViewing && 'pointer user-select-none'"
                    ref="resumeTitleBtn"
                  >
                    <div
                      @click="
                        !isViewing &&
                          (showKeywordDropdown = !showKeywordDropdown)
                      "
                    >
                      Search Keyword in
                      <span
                        :class="isViewing ? 'cv-small-grey' : 'cv-small-blue'"
                      >
                        {{ SEARCH_TYPES[search.searchType] }}
                      </span>
                      <img
                        class="ml-1"
                        src="../../assets/cvsearch/bluesmallarrow.svg"
                        alt=""
                      />
                    </div>
                    <!-- RESUME TITLE DROPDOWN -->
                    <div
                      class="btns-stckd resumeTitle-parent"
                      v-if="showKeywordDropdown"
                      ref="resumeTitleDropDown"
                      v-closable="{
                        exclude: ['resumeTitleDropDown', 'resumeTitleBtn'],
                        handler: 'hideKeywordDropdown',
                      }"
                    >
                      <b-form-radio-group
                        v-model="search.searchType"
                        @change="showKeywordDropdown = false"
                        :options="toDropdownOptions(SEARCH_TYPES)"
                        text-field="text"
                        value-field="value"
                        buttons
                        stacked
                        name="radio-stacked"
                      >
                      </b-form-radio-group>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex mt-3">
                <div class="w-50">
                  <div class="acs-input-head">Experience</div>
                  <div class="d-flex align-items-center mt-1 pr-25px">
                    <div class="">
                      <b-form-input
                        :disabled="isViewing"
                        class="cs-laptopinput no-spinner"
                        placeholder="Enter"
                        v-model="search.experienceFrom"
                        type="text"
                        @keypress="preventKeys($event, ['e', '+', '-'])"
                      ></b-form-input>
                    </div>
                    <div class="cv-grey-txt ml-2 mr-2">to</div>

                    <div class="position-relative">
                      <div class="d-flex align-items-center">
                        <div class="">
                          <b-form-input
                            :disabled="isViewing"
                            class="cs-laptopinput no-spinner"
                            :class="{ error: !$v.search.experienceTo.greater }"
                            placeholder="Enter"
                            v-model="$v.search.experienceTo.$model"
                            type="text"
                            @keypress="preventKeys($event, ['e', '+', '-'])"
                          ></b-form-input>
                        </div>
                        <div class="cv-grey-txt ml-2">Years</div>
                      </div>
                      <div
                        class="errortxt position-absolute"
                        v-if="!$v.search.experienceTo.greater"
                      >
                        Should be more than {{ search.experienceFrom }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="w-50 ml-4">
                  <div class="acs-input-head">Annual CTC</div>
                  <div class="d-flex align-items-center mt-1 pr-25px">
                    <div class="">
                      <b-form-input
                        :disabled="isViewing"
                        class="cs-laptopinput no-spinner"
                        placeholder="Enter"
                        v-model="search.salaryFrom"
                        type="text"
                        @keypress="preventKeys($event, ['e', '+', '-'])"
                      ></b-form-input>
                    </div>
                    <div class="cv-grey-txt ml-2 mr-2">to</div>

                    <div class="position-relative">
                      <div class="d-flex align-items-center">
                        <div class="">
                          <b-form-input
                            :disabled="isViewing"
                            class="cs-laptopinput no-spinner"
                            :class="{ error: !$v.search.salaryTo.greater }"
                            placeholder="Enter"
                            v-model="$v.search.salaryTo.$model"
                            type="text"
                            @keypress="preventKeys($event, ['e', '+', '-'])"
                          ></b-form-input>
                        </div>
                        <div class="cv-grey-txt ml-2">LPA</div>
                      </div>
                      <div
                        class="errortxt position-absolute"
                        v-if="!$v.search.salaryTo.greater"
                      >
                        Should be more than {{ search.salaryFrom }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex mt-3">
                <div class="w-50">
                  <div class="topDiv cv-field panellist-tags" @click.stop="">
                    <div class="acs-input-head">Current Location</div>
                    <b-form-tags
                      :disabled="isViewing"
                      class="text-truncate cv-input-pan w-100 mt-1"
                      :placeholder="isViewing ? '' : 'Enter'"
                      type="text"
                      remove-on-delete
                      duplicate-tag-text=""
                      v-model="search.location"
                    ></b-form-tags>
                  </div>
                  <div class="pff-checkbox mt-1">
                    <b-form-checkbox
                      size="sm"
                      :disabled="isViewing"
                      v-model="search.willingToRelocate"
                      @change="search.preferredLocation = []"
                      >Willing to relocate</b-form-checkbox
                    >
                  </div>
                </div>
                <div class="w-50 ml-4">
                  <div class="topDiv cv-field panellist-tags" @click.stop="">
                    <div class="acs-input-head">Preferred Location</div>
                    <b-form-tags
                      :key="search.willingToRelocate"
                      :disabled="isViewing || !search.willingToRelocate"
                      class="text-truncate cv-input-pan w-100 mt-1"
                      :placeholder="isViewing ? '' : 'Enter'"
                      type="text"
                      remove-on-delete
                      duplicate-tag-text=""
                      v-model="search.preferredLocation"
                    ></b-form-tags>
                  </div>
                </div>
              </div>
              <div class="mt-3">
                <div class="acs-input-head">
                  Notice period / Availability to Join
                </div>
                <div class="mt-1 d-flex flex-wrap">
                  <div
                    v-for="(period, key) in NOTICE_PERIODS"
                    :key="key"
                    :class="[
                      search.noticePeriod === key
                        ? isViewing
                          ? 'cv-notice-period-tags-sel-dis'
                          : 'cv-notice-period-tags-sel'
                        : 'cv-notice-period-tags',
                      !isViewing && 'pointer',
                    ]"
                    class="mr-2 mb-1"
                    @click="!isViewing && toggleNoticePeriod(key)"
                  >
                    {{ period }}
                  </div>
                </div>
              </div>
              <div class="mt-3 d-flex">
                <!-- <div class="w-50">
                  <div class="topDiv cv-field panellist-tags" @click.stop="">
                    <MultiSelectSearch
                      showLabel
                      label="Gender"
                      :options="toDropdownOptions(GENDERS)"
                      :selected="search.gender"
                      @select-value="search.gender = $event"
                      :isDisabled="isViewing"
                    />
                  </div>
                </div> -->
                <div class="w-50">
                  <div class="acs-input-head">Candidate Age</div>
                  <div class="d-flex align-items-center mt-1 pr-25px">
                    <div class="">
                      <b-form-input
                        class="cs-laptopinput no-spinner"
                        :placeholder="isViewing ? '' : 'Enter'"
                        :disabled="isViewing"
                        v-model="search.ageFrom"
                        type="text"
                        @keypress="preventKeys($event, ['e', '+', '-', '.'])"
                      ></b-form-input>
                    </div>
                    <div class="cv-grey-txt ml-2 mr-2">to</div>

                    <div class="position-relative">
                      <div class="d-flex align-items-center">
                        <div class="">
                          <b-form-input
                            class="cs-laptopinput no-spinner"
                            :class="{ error: !$v.search.ageTo.greater }"
                            :placeholder="isViewing ? '' : 'Enter'"
                            :disabled="isViewing"
                            v-model="$v.search.ageTo.$model"
                            type="text"
                            @keypress="
                              preventKeys($event, ['e', '+', '-', '.'])
                            "
                          ></b-form-input>
                        </div>
                        <div class="cv-grey-txt ml-2">Years</div>
                      </div>
                      <div
                        class="errortxt position-absolute"
                        v-if="!$v.search.ageTo.greater"
                      >
                        Should be more than {{ search.ageFrom }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mt-3 d-flex">
                <div class="w-50">
                  <div class="topDiv cv-field panellist-tags" @click.stop="">
                    <MultiSelectSearch
                      showLabel
                      label="Work Type"
                      :options="toDropdownOptions(WORK_TYPE)"
                      :isDisabled="isViewing"
                      :selected="search.workType"
                      @select-value="search.workType = $event"
                    />
                  </div>
                </div>
                <div class="w-50 ml-4 topDiv">
                  <div class="topDiv cv-field panellist-tags" @click.stop="">
                    <MultiSelectSearch
                      showLabel
                      label="Job Type"
                      :options="toDropdownOptions(EMPLOYMENT_TYPE)"
                      :selected="search.employmentType"
                      @select-value="search.employmentType = $event"
                      :isDisabled="isViewing"
                    />
                  </div>
                </div>
              </div>
              <div class="d-flex align-items-center mt-3">
                <div @click="showAdvanced = !showAdvanced">
                  <img
                    v-if="showAdvanced"
                    src="../../assets/customfield/modalTopArrow.svg"
                    alt=""
                  />
                  <img
                    v-else
                    src="../../assets/customfield/modalDownArrow.svg"
                    alt=""
                  />
                </div>
                <div class="cs-bluetxt ml-2 mr-3">Advanced</div>
                <div class="modal-horizontal-line"></div>
              </div>
              <b-collapse v-model="showAdvanced">
                <div class="mt-3">
                  <label class="acs-input-head">IT Skills</label>
                  <div
                    class="d-flex"
                    :class="index === 0 ? 'mt-1' : 'mt-2'"
                    :key="index"
                    v-for="(skill, index) in search.itSkills"
                  >
                    <div class="w-50 position-relative">
                      <b-form-input
                        class="cs-laptopinput pl-32px"
                        placeholder="Enter skill name"
                        v-model="skill.skillName"
                        :disabled="isViewing"
                      ></b-form-input>
                      <template v-if="isViewing">
                        <img
                          v-if="skill.mandatory"
                          class="cv-star-skill-pos"
                          src="../../assets/cvsearch/greyfilledstar.svg"
                          alt=""
                        />
                        <img
                          v-else
                          class="cv-star-skill-pos"
                          src="../../assets/cvsearch/greyEmptystar.svg"
                          alt=""
                        />
                      </template>
                      <template v-else>
                        <img
                          v-if="skill.mandatory"
                          class="cv-star-skill-pos"
                          src="../../assets/cvsearch/filledstar.svg"
                          alt=""
                          @click="skill.mandatory = false"
                        />
                        <img
                          v-else
                          class="cv-star-skill-pos"
                          src="../../assets/cvsearch/emptystar.svg"
                          alt=""
                          @click="skill.mandatory = true"
                        />
                      </template>
                    </div>
                    <div class="w-50 ml-4 d-flex align-items-center">
                      <b-form-input
                        class="cs-laptopinput no-spinner"
                        placeholder="Enter experience in years"
                        v-model="skill.yearsOfExp"
                        :disabled="isViewing"
                        type="text"
                        @keypress="preventKeys($event, ['e', '+', '-'])"
                      ></b-form-input>
                      <img
                        v-if="isViewing || search.itSkills.length === 1"
                        class="ml-3"
                        src="../../assets/img/accessconnew/Delete.svg"
                        alt=""
                      />
                      <img
                        v-else
                        class="ml-3 pointer"
                        src="../../assets/img/accessconnew/blueBin.svg"
                        alt=""
                        @click="!isViewing && search.itSkills.splice(index, 1)"
                      />
                    </div>
                  </div>
                  <div class="cv-small-grey d-flex align-items-center mt-2">
                    <div
                      @click="
                        !isViewing &&
                          search.itSkills.push({
                            skillName: '',
                            yearsOfExp: '',
                            mandatory: false,
                          })
                      "
                      :class="isViewing ? '' : 'pointer'"
                    >
                      <img
                        class="mr-1"
                        src="../../assets/cvsearch/bluePlus.svg"
                        alt=""
                      />Add another IT Skill
                    </div>
                  </div>
                </div>
                <div class="d-flex mt-3">
                  <div class="w-50">
                    <div class="topDiv cv-field panellist-tags" @click.stop="">
                      <label class="acs-input-head">Industry</label>
                      <b-form-tags
                        class="text-truncate cv-input-pan w-100"
                        :placeholder="isViewing ? '' : 'Enter'"
                        :disabled="isViewing"
                        type="text"
                        remove-on-delete
                        duplicate-tag-text=""
                        v-model="search.industry"
                      ></b-form-tags>
                    </div>
                  </div>
                  <div class="w-50 ml-4">
                    <div class="topDiv cv-field panellist-tags" @click.stop="">
                      <label class="acs-input-head">Designation</label>
                      <b-form-tags
                        class="text-truncate cv-input-pan w-100"
                        :placeholder="isViewing ? '' : 'Enter'"
                        :disabled="isViewing"
                        type="text"
                        remove-on-delete
                        duplicate-tag-text=""
                        v-model="search.designation"
                      ></b-form-tags>
                    </div>
                  </div>
                </div>
                <div class="mt-3 d-flex">
                  <div class="w-50 position-relative">
                    <div class="acs-input-head">Min. Education</div>
                    <SelectDropdown
                      :placeholder="'Select'"
                      :disableDropdown="isViewing"
                      :dropdownOptions="toDropdownOptions(EDUCATION)"
                      :value="search.minimumEducation"
                      :text="EDUCATION[search.minimumEducation]"
                      @setValue="search.minimumEducation = $event"
                    />
                  </div>
                  <div class="w-50 ml-4"></div>
                </div>
                <div class="d-flex mt-3">
                  <div class="w-50 position-relative">
                    <div class="acs-input-head">Active in</div>
                    <SelectDropdown
                      :placeholder="'Select'"
                      :disableDropdown="isViewing"
                      :dropdownOptions="toDropdownOptions(ACTIVE_IN)"
                      :value="
                        search.activeInDays
                          ? search.activeInDays.toString()
                          : ''
                      "
                      :text="ACTIVE_IN[search.activeInDays]"
                      @setValue="search.activeInDays = $event"
                    />
                  </div>
                  <div class="w-50 ml-4 position-relative">
                    <div class="acs-input-head">View Profile</div>
                    <SelectDropdown
                      :placeholder="'Select'"
                      :disableDropdown="isViewing"
                      :dropdownOptions="toDropdownOptions(VIEW_PROFILE)"
                      :value="search.viewProfile"
                      :text="VIEW_PROFILE[search.viewProfile]"
                      @setValue="search.viewProfile = $event"
                    />
                  </div>
                </div>
              </b-collapse>
            </div>
          </div>
          <div
            class="
              d-flex
              align-items-center
              justify-content-end
              border-top
              pr-4
              bluebtn
              pt-2
              mt-2
            "
          >
            <b-button class="acs-cancelBtn-modal mr-4" @click="cancelSearch"
              >Cancel</b-button
            >
            <b-button
              class="acs-addBtn-modal"
              :disabled="$v.search.$invalid"
              @click="handleSearchCandidates"
              >{{
                isEditing && !updateAndSearch ? "Update & Search" : "Search"
              }}</b-button
            >
          </div>
        </div>
      </transition>
    </div>
    <b-modal id="delete-search" centered hide-footer hide-header @hidden="$bvModal.hide('delete-search')">
      <div class="d-flex">
        <div class="mr-3">
          <img src="../../assets/img/accessconnew/deletemodal.svg" alt />
        </div>
        <div>
          <div class="d-flex justify-content-between">
            <div class="acs-modal-head">Delete Search</div>
            <div @click="$bvModal.hide('delete-search')">
              <img
                class="rotate-on-hover"
                src="../../assets/img/accessconnew/blueCross.svg"
                alt
              />
            </div>
          </div>
          <div class="acs-modal-content pr-3 mt-1">
            Are you sure you want to delete this saved search? This action
            cannot be undone.
          </div>
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-end mt-4 bluebtn">
        <b-button
          class="acs-cancelBtn-modal mr-3"
          @click="$bvModal.hide('delete-search')"
          >Cancel</b-button
        >
        <b-button class="acs-addBtn-modal" @click="deleteSearch(search, false)"
          >Delete</b-button
        >
      </div>
    </b-modal>
  </div>
</template>
<script>
import SelectDropdown from "../../components/fixedcomponents/Select.vue";
import {
  deleteSearchProfiles,
  getSavedSearches,
  updatesearchProfiles,
} from "../../utils/apiFunctions";
import Spinner from "../../components/fixedcomponents/Spinner.vue";
import cvSearch from "../../components/mixin/cvSearch";
import toast from "../../components/mixin/toast";
import MultiSelectSearch from "../../components/InputComponents/MultiSelectSearch.vue";
import { mapGetters } from "vuex";

const VIEW = "view";
const EDIT = "edit";
const CREATE = "create";

export default {
  name: "cvSearch",
  data() {
    return {
      //pagination and filters
      options: [1, 2, 3, 4],
      test: 3,
      page: 0,
      pageEnd: null,
      total: null,
      count: 20,
      sort: 0,
      filter: {
        keywords: [],
        experienceFrom: "",
        experienceTo: "",
      },
      tempFilter: {
        keywords: [],
        experienceFrom: "",
        experienceTo: "",
      },

      loaderStatus: false,
      loadingMore: false,
      savedSearches: null,
      actionType: null,

      //search
      currentKeyword: "",
      currentGender: "",

      //dropdowns
      showKeywordDropdown: false,

      loopvar: 20,
      showAdvanced: true,
      showFilter: false,
      showSidePanel: false,
      search: {}, // refer resetSearch() for structure
      updateAndSearch: true,
      isCreated: true,
      searchCopy: {},
    };
  },
  components: {
    SelectDropdown,
    MultiSelectSearch,
    Spinner,
  },
  mixins: [toast, cvSearch],

  created() {
    this.getSavedSearches();
    this.resetSearch(true);
  },
  beforeDestroy() {
    this.$refs["table-body"].removeEventListener("scroll", this.handleScroll);
  },

  methods: {
    cancelSearch() {
      this.showSidePanel = false;
      this.currentKeyword = "";
      this.resetSearch(true);
    },
    validateKeywords(keyword) {
      return !this.tempFilter.keywords.some(
        (k) => k.toLowerCase() === keyword.toLowerCase()
      );
    },
    compareSearchDetails() {
      this.updateAndSearch =
        JSON.stringify(this.search) === JSON.stringify(this.searchCopy);
      this.$forceUpdate();
    },
    async handleSearchCandidates() {
      if (this.isEditing && !this.updateAndSearch) {
        await updatesearchProfiles({
          ...this.search,
        });
      }
      await this.searchCandidates();
    },
    goBackPointer() {
      switch (this.$route.name) {
        case "cvSearchTalentPool":
          this.$router.push({
            name: "TalentPool",
          });
          break;
        case "cvSearchKanban":
          this.$router.push({
            name: "Kanban",
            query: {
              jobID: this.$route.query.jobID,
              customerID: this.$route.query.customerID,
              cardName: this.$route.query.cardName,
            },
          });
          break;

        default:
          this.$router.push({
            name: "TalentPool",
          });
          break;
      }
    },
    hideKeywordDropdown() {
      this.showKeywordDropdown = false;
    },
    closeFilter() {
      this.showFilter = false;
    },
    handleScroll() {
      if (
        this.$refs["table-body"].scrollTop +
          this.$refs["table-body"].clientHeight >=
        this.$refs["table-body"].scrollHeight
      ) {
        if (this.total !== this.pageEnd) {
          this.loadingMore = true;
          this.page++;
          this.getSavedSearches();
        }
      }
    },
    goToBookmarked() {
      this.$router.push({
        name: "BookmarkedCandidates",
      });
    },
    toggleFilter() {
      if (!this.showFilter) {
        this.tempFilter = { ...this.filter };
      }
      this.showFilter = !this.showFilter;
    },
    clearFilter() {
      this.filter = {
        keywords: [],
        experienceFrom: null,
        experienceTo: null,
      };
      this.page = 0;
      this.savedSearches = [];
      this.getSavedSearches();
      this.showFilter = false;
    },
    applyFilter() {
      this.filter = { ...this.tempFilter };
      this.page = 0;
      this.savedSearches = [];
      this.getSavedSearches();
      this.showFilter = false;
    },
    changeSort() {
      if (this.sort === 0) this.sort = -1;
      else if (this.sort === -1) this.sort = 1;
      else this.sort = 0;
      this.page = 0;
      this.savedSearches = [];
      this.getSavedSearches();
    },
    createSearch() {
      this.resetSearch(true);
      this.actionType = CREATE;
      this.showSidePanel = true;
    },
    viewSearch(search) {
      this.resetSearch(true);
      this.search = { ...this.search, ...search };
      this.actionType = VIEW;
      this.showSidePanel = true;
    },
    editSearch(search) {
      this.resetSearch(true);
      this.search = { ...this.search, ...search };
      this.searchCopy = JSON.parse(
        JSON.stringify({ ...this.search, ...search })
      );
      this.isCreated = true;
      this.actionType = EDIT;
      this.showSidePanel = true;
      this.updateAndSearch = true;
    },
    async deleteSearch(search, showModal = true) {
      if (showModal) {
        this.resetSearch(true);
        this.search = { ...this.search, ...search };
        this.$bvModal.show("delete-search");
      } else {
        try {
          let payload = {
            searchID: this.search.searchID,
          };
          let res = await deleteSearchProfiles(payload);
          if (res.status == 200) {
            this.successModal("Saved search deleted successfully");
          }
          this.$bvModal.hide("deletesavemodel");
          this.savedSearches = this.savedSearches.filter(
            (s) => s.searchID !== search.searchID
          );
        } catch (error) {
          console.error(error);
        }
        this.$bvModal.hide("delete-search");
      }
    },
    formatExperience(from, to) {
      if (!from && !to) return ``;
      else if (!from) return `<${to}`;
      else if (!to) return `>${from}`;
      else return `${from} - ${to}`;
    },
    async searchCandidates() {
      this.$store.dispatch("cvSearchVUEX/searchProfilesData", this.search);
      this.$store.commit("cvSearchVUEX/saveAppliedSearch", this.search);

      this.$route.meta.title = "Search Profiles";
      this.$router.push({
        name: "SearchCandidate",
      });
    },
    async getSavedSearches() {
      if (!this.savedSearches || !this.savedSearches.length)
        this.loaderStatus = true;
      try {
        const res = await getSavedSearches({
          ...this.filter,
          page: this.page,
          searchQuery: this.searchQuery,
          count: this.count,
          sortBy:
            this.sort !== 0
              ? {
                  column: "title",
                  order: this.sort === 1 ? true : false,
                }
              : {
                  column: "createdAt",
                  order: false,
                },
        });
        if (res.status == 200) {
          if (this.savedSearches) {
            this.savedSearches = [...this.savedSearches, ...res.data.data.data];
          } else {
            this.savedSearches = res.data.data.data;
            this.$nextTick(() => {
              this.$refs["table-body"].addEventListener(
                "scroll",
                this.handleScroll
              );
            });
          }
          this.total = res.data.data.total;
          this.pageEnd = res.data.data.pageEnd;
        } else {
          this.savedSearches = [];
        }
      } catch (err) {
        console.error(err);
      }

      this.loaderStatus = false;
      this.loadingMore = false;
    },
  },
  computed: {
    fromToFieldError() {
      return {
        experience:
          !this.search.experienceFrom || !this.search.experienceTo
            ? false
            : this.search.experienceFrom > this.search.experienceTo,
      };
    },
    isFilterChanged() {
      return JSON.stringify(this.filter) !== JSON.stringify(this.tempFilter);
    },

    isFiltered() {
      return (
        this.filter.keywords.length > 0 ||
        this.filter.experienceFrom ||
        this.filter.experienceTo
      );
    },
    isViewing() {
      return this.actionType === "view";
    },
    isEditing() {
      return this.actionType === "edit";
    },
    isCreating() {
      return this.actionType === "create";
    },
    ...mapGetters("searchVUEX", {
      searchQuery: "getSearchQuery",
    }),
    ...mapGetters(["roles"]),
  },
  watch: {
    searchQuery(newValue, oldValue) {
      if (newValue != oldValue) {
        if (newValue != "Loader") {
          this.page = 0;
          this.savedSearches = [];
          this.getSavedSearches();
        }
      }
    },
    search: {
      handler() {
        if (!this.isCreated) this.compareSearchDetails();
        else this.isCreated = false;
      },
      deep: true,
    },
  },
};
</script>
<style scoped>
.cvsearch-custom-cv-tags .form-control {
  height: 29px;
  line-height: 1.5;
  background-color: #fff;
  border: none;
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-size: 13px;
  color: #333333;
  width: 100%;
  padding: 0;
}

.cvsearch-custom-cv-tags {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
}

.cvsearch-custom-cv-tags::-webkit-scrollbar {
  width: 5px;
  height: 2px;
}

.w-110px {
  width: 110px !important;
}

.truncate-section {
  max-width: 100%;
  width: fit-content;
  display: inherit;
}
</style>
